

exports.__esModule = true;
var constants = exports.constants = {
    regex: {
        safeProtocols: '^\s*(https?|s?ftp|mailto|tel|file):',
        protocolsWithDeeplink: '^\s*(https?|s?ftp|mailto|tel|file|com\.[a-z]+(\.[a-z]+)*):'
    }
};


//////////////////
// WEBPACK FOOTER
// ./js/lib/constants.js
// module id = ./js/lib/constants.js
// module chunks = main-code-split